/* eslint-disable eqeqeq */
import React, { Component, Fragment } from "react";
import {
  Divider,
  IconButton,
  Tooltip,
  CircularProgress,
  Toolbar,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import R303GeneralPricingTableComponent from "./R303GeneralPricingTableComponent";
import FilterIcon from "mdi-material-ui/FilterOutline";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import ChangeStatusWithDialog from "../../../components/ChangeStatusWithDialog/ChangeStatusWithDialogComponent.js";
import NavBar from "../../../components/NavBar/NavBar";
import { HttpRequest } from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
class F303GeneralPricingReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      showSearchBar: false,

      Data: [],

      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      isLoginMenu: false,
      isReload: true,
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  onClearFilters = () => {
    this.setState({
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      eventDate: date,
    });
  };

  getData = async () => {
    // e.preventDefault();
    this.setState({
      isLoading: true,
    });
    // const data = new FormData(e.target);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductsPriceView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].action = (
            <ChangeStatusWithDialog
              isActive={res.data[i].isActive}
              recordId={res.data[i].id}
              DeleteData={this.DeleteData}
              dialogTitle="Confirm Status Change"
              dialogText={`Do you really want to ${res.data[i].isActive == 1 ? "deactivate" : "activate"} this record? This will deactivate the current general discount!`}
              handleChangeStatus={(recordId, isActive) =>
                this.handleChangeStatus(recordId, isActive)
              }
              onEditURL={`#/F303GeneralPricingFormV3/${res.data[i].id}`}
            />
          );
        }
        this.setState({
          Data: res.data || [],
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({
      isLoading: false,
    });
  };

  DeleteData = async () => {
    // event.preventDefault();
    // const data = new FormData(event.target);
    // const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C06CommonSchoolsDelete`;
    // await fetch(url, {
    //   method: "POST",
    //   body: data,
    //   headers: new Headers({
    //     Authorization: "Bearer " + localStorage.getItem("uclAdminToken"),
    //   }),
    // })
    //   .then((res) => {
    //     if (!res.ok) {
    //       throw res;
    //     }
    //     return res.json();
    //   })
    //   .then(
    //     (json) => {
    //       if (json.CODE === 1) {
    //         this.handleOpenSnackbar("Deleted", "success");
    //         this.getData();
    //       } else {
    //         //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
    //         this.handleOpenSnackbar(
    //           json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE,
    //           "error"
    //         );
    //       }
    //       console.log(json);
    //     },
    //     (error) => {
    //       if (error.status === 401) {
    //         this.setState({
    //           isLoginMenu: true,
    //           isReload: true,
    //         });
    //       } else {
    //         //alert('Failed to fetch, Please try again later.');
    //         this.handleOpenSnackbar(
    //           "Failed to fetch, Please try again later.",
    //           "error"
    //         );
    //         console.log(error);
    //       }
    //     }
    //   );
  };

  handleChangeStatus = async (recordId, isActive) => {
    const data = new FormData();
    data.append("id", recordId);
    data.append("isActive", isActive);
    // const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C06CommonSchoolsDelete`;

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductPriceActiveStatusUpdate`,
      data,
      "authorize"
    );
    console.log(res);
    if (res.isSuccess) {
      this.handleSnackbar(true, "Status Changed", "success");
      window.location.reload();
      return "1";
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }

      return "0";
    }
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  componentDidMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.getData();
  }

  render() {
    const columns = [
      { name: "SRNo", title: "SR#" },

      { name: "priceLabel", title: "Label" },

      { name: "isActiveStr", title: "Active" },

      { name: "Category", title: "Categories" },

      {
        name: "effectiveFromStr",
        title: "Effective\xa0From",
        wordWrapEnabled: true,
      },
      {
        name: "effectiveToStr",
        title: "Effective\xa0To",
        wordWrapEnabled: true,
      },
      {
        name: "statusLabel",
        title: "Status",
        wordWrapEnabled: true,
        getCellValue: (row) => {
          return (
            <div
              style={{
                color: `${
                  row.statusId == 3
                    ? "darkred"
                    : row.statusId == 2
                    ? "#be4f00"
                    : "black"
                }`,
                overflowWrap: "break-word",
                wordBreak: "break-word" /* Fallback for older browsers */,
                whiteSpace: "normal",
              }}
            >
              {row.statusLabel}
            </div>
          );
        },
      },
      { name: "action", title: "Action" },
    ];

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20,
          }}
        >
          <Toolbar>
            <NavBar isAuthorize title="General Pricing" />
            {/* <LoginMenu
                    reload={this.state.isReload}
                    open={this.state.isLoginMenu}
                    handleClose={() => this.setState({ isLoginMenu: false })}
                    /> */}
          </Toolbar>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              General Pricing Report
            </Typography>
            {/* <img alt="" src={ExcelIcon} onClick={() => this.downloadExcelData()} style={{
                            height: 30, width: 32,
                            cursor: `${this.state.isDownloadExcel ? 'wait' : 'pointer'}`,
                        }}
                        /> */}
            <div style={{ float: "right" }}>
              {/* <Hidden xsUp={true}> */}
              {/* <Tooltip title="Search Bar">
                                    <IconButton
                                        onClick={this.handleToggleSearchBar}
                                    >
                                        <FilterIcon fontSize="default" color="primary"/>
                                    </IconButton>
                                </Tooltip> */}
              {/* </Hidden> */}
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                >
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />

          {this.state.isLoading ? (
            <div
              style={{
                marginTop: 50,
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress
                size={50}
                style={{ color: "rgb(29, 95, 152)", fontWeight: 600 }}
              />
            </div>
          ) : (
            <>
              {this.state.Data && (
                <R303GeneralPricingTableComponent
                  data={this.state.Data}
                  columns={columns}
                  showFilter={this.state.showTableFilter}
                />
              )}
            </>
          )}

          {/* {this.state.Data && (
            <
              data={this.state.Data}
              columns={columns}
              showFilter={this.state.showTableFilter}
            />
          )} */}
          {/* ) : (
          //   <Grid container justify="center" alignItems="center">
          //     <CircularProgress />
          //   </Grid>
          // )} */}
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}
export default F303GeneralPricingReport;
